import {defaultsDeep, isObjectLike} from 'lodash'

/**
 * @param options.step {int} - whitespace number
 */
function jsonViewer(options = {}) {
  this.options = defaultsDeep(options, {
    step: 2,
    valueTag: 'span',
    higherValues: [],
    lowerValues: [],
    colors: {
      string: '#c72a2a',
      number: '#4646b7',
      undefined: '#A598B1',
      null: 'blue',
      higherValue: '',
      lowerValue: ''
    }
  })
}

const c = `<span style="color: transparent">,</span>`
const t = `<span style="color: transparent">"</span>`

/**
 * @param step {number} - start position
 * @return {string}
 */
jsonViewer.prototype.parse = function (obj, step = 0) {
  step += this.options.step

  let html = ''

  if (step === this.options.step) html += `${this.openScope(obj)}\n`
  Object.keys(obj)
    .filter(key => !key.match('__default__')) // filtering default values
    .forEach((key, i, arr) => {
      // whitespaces
      html += this.addWhitespaces(step)

      const isLastProp = i === arr.length - 1

      if (_.isDate(obj[key])) obj[key] = obj[key].toString()

      if (isObjectLike(obj[key])) {
        html += _.isArray(obj) ? '' : `${t}${key}${t}: ` // key:
        html += `${this.openScope(obj[key])}` //                {
        html += _.isEmpty(obj[key]) ? '' : '\n' //
        html += this.parse(obj[key], step) //                  ....
        html += this.addWhitespaces(step) + this.closeScope(obj[key]) + `${c}\n`//   }
      } else {
        html += `<span style="color:${_.includes(this.options.higherValues, key) ? 'green' : _.includes(this.options.lowerValues, key) ? '#c72a2a' : ''}">${t}${key}${t}</span>: ${this.makeValue(obj[key])}${isLastProp ? '' : c}`;
        html += this.makeDefaultValue(obj, key);
        html += '\n';
      }
  })
  if (step === this.options.step) html += `${this.closeScope(obj)}\n`;

  return html
}

jsonViewer.prototype.addWhitespaces = function (count = 0) {
  let html = ''
  for (let i = 0; i < count; i++) {
    html += '&nbsp'
  }
  return html
}

/** for objects or objects */
jsonViewer.prototype.openScope = function (obj) {
  return _.isArray(obj) ? '[' : '{'
}
jsonViewer.prototype.closeScope = function (obj) {
  return _.isArray(obj) ? ']' : '}'
}

/** @param value {string|number|null}  */
jsonViewer.prototype.makeValue = function (value) {
  let type = typeof value
  if (_.isNull(value)) type = 'null'

  let html = `<${this.options.valueTag} style="color:${this.options.colors[type]}; ${type === 'string' && 'max-width: 500px; display: inline-block; vertical-align: top; word-break: break-all;' || ''}">`

  if (type === 'string') html += this.createString(value)
  else html += value

  html += `<\/${this.options.valueTag}\>`

  return html
}

jsonViewer.prototype.makeDefaultValue = function(obj, key) {
  const defaultKey = `__default__${key}`;
  if (obj.hasOwnProperty(defaultKey)) {
    const defaultValue = obj[defaultKey];
    return `&nbsp&nbsp&nbsp&nbsp<span>[${defaultValue}]</span>`
  }
  return '';
}

jsonViewer.prototype.createString = function (str) {
  // const max = 50;
  // const rows = Math.ceil(str.length / max);
  //
  // let i = 0;
  // let newStr = '';
  // for (; i < rows; i++) {
  //   if (i > 0) { newStr += '\n'; }
  //   const position = i * max;
  //   newStr += str.slice(position, position + max);
  // }

  return `"${str.replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;")}"`
}

export default jsonViewer



// WEBPACK FOOTER //
// ./src/components/json/JsonViewer.js